import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueCookies from 'vue-cookies'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import routerSurface from './router/routerSurface.js'
import 'normalize.css/normalize.css'
import No from '@/components/no'
import './styles/reset.less'
import './assets/font/iconfont.css'
import axios from './util/axios'
import api from './util/api'
//生产环境
if (process.env.NODE_ENV == 'production') {
  console.log = function () {}
}
console.warn = function () {}
Vue.use(ElementUI)
Vue.use(VueCookies)
Vue.component('No', No)
Vue.prototype.$axios = axios
Vue.prototype.$api = api
Vue.prototype.routerSurface = routerSurface
Vue.prototype.$ak = 'myAKa'
Vue.config.productionTip = false
Vue.config.silent = true
new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
